import {
  WIZARD_SET_PAGE_COUNT,
  WIZARD_SET_DEVICE,
  WIZARD_PAGE_NEXT,
  WIZARD_PAGE_SKIP,
  WIZARD_PAGE_PREV,
  WIZARD_DONE,
  WIZARD_RESET,
  WIZARD_ERROR,
  WIZARD_ALERT,
} from '../constants/actionTypes';

export const setPageCount = count => ({ type: WIZARD_SET_PAGE_COUNT, count });
export const setDevice = deviceId => ({ type: WIZARD_SET_DEVICE, deviceId });
export const nextPage = () => ({ type: WIZARD_PAGE_NEXT });
export const skipPage = () => ({ type: WIZARD_PAGE_SKIP });
export const prevPage = () => ({ type: WIZARD_PAGE_PREV });
export const wizardDone = message => ({ type: WIZARD_DONE, message });
export const wizardReset = () => ({ type: WIZARD_RESET });
export const wizardError = (error, showDeviceInput) => ({
  type: WIZARD_ERROR,
  error,
  showDeviceInput,
});
export const wizardAlert = alert => ({ type: WIZARD_ALERT, alert });
